import {Image} from 'react-bootstrap'

const LanguageUsed = ({language}) => {
    return <Image className="langUsed" src={language} fluid/>
}

export default LanguageUsed
